import { Theme } from '@mui/material'
import { useEffect } from 'react'
import { Dispatch } from 'redux'
import {
  addMarkers,
  removeMarkers,
} from '../../../components/MapSection/features/publicWaterSystem'
import { fetchAggregatedWaterSystems } from '../../../components/MapSection/features/publicWaterSystem'
import {
  updateBoundingBoxStyles,
  updateCountyStyles,
  updateRegionStyles,
} from '../../../components/MapSection/features/publicWaterSystem'
import { stateToRegionByName } from '../../../constants/Map'
import { IAddress } from '../../../store/Address'

import {
  MapWaterSystemsMetricsActions,
  WaterSystemsMetricsActions,
} from '../../../store/publicWaterSystem'
import { ZoomLevel } from '../../../store/publicWaterSystem'
import { BoundingBox } from '../../../types'

interface MapRefs {
  regionsViolationsRef: React.MutableRefObject<any>
  countyViolationsRef: React.MutableRefObject<any>
  markersRef: React.MutableRefObject<any[]>
}

interface MapEffectsProps {

  boundingBox: BoundingBox | undefined
  coordinates: any[]
  countyViolations: any[]
  dispatch: Dispatch
  isMobile?: boolean
  mapCenter: any
  mapCenterRef: React.MutableRefObject<any>
  mapRef: React.RefObject<mapboxgl.Map>
  prevSelectedCode: React.MutableRefObject<any>
  refs: MapRefs
  regionsViolations: any[]
  selectedAddress: IAddress | null
  selectedAddressRef: React.MutableRefObject<any>
  selectedCounty: any
  selectedState: any
  selectedStateRef: React.MutableRefObject<any>
  states: any
  statesRef: React.MutableRefObject<any>
  theme: Theme
  waterSystemMapMetrics: any
  waterSystemMapMetricsRef: React.MutableRefObject<any>
  zoomLevel: string | ZoomLevel,
  zoom: {zoom:number, ease:boolean}
}

export const useMapEffects = ({
  boundingBox,
  coordinates,
  countyViolations,
  dispatch,
  isMobile = false,
  mapCenter,
  mapCenterRef,
  mapRef,
  prevSelectedCode,
  refs,
  regionsViolations,
  selectedAddress,
  selectedAddressRef,
  selectedCounty,
  selectedState,
  selectedStateRef,
  states,
  statesRef,
  theme,
  waterSystemMapMetrics,
  waterSystemMapMetricsRef,
  zoomLevel,
  zoom
}: MapEffectsProps) => {
  /* Set zoom of map through store*/
  useEffect(() => {
    if(zoom.ease) {
      mapRef?.current?.zoomTo(zoom.zoom)
    } else {
      mapRef.current?.setZoom(zoom.zoom)
    }

  },[zoom, mapRef])
  useEffect(() => {

    if (zoomLevel === ZoomLevel.REGION) {
      fetchAggregatedWaterSystems(dispatch, zoomLevel as ZoomLevel)
      dispatch(MapWaterSystemsMetricsActions.fetchMapWaterSystemMetricsAsync({}) as any)
    }
  }, [zoomLevel, dispatch])

  // Update region styles
  useEffect(() => {

    if (mapRef.current && zoomLevel === ZoomLevel.REGION) {

      if (!mapRef.current.isStyleLoaded()) {
        const onStyleLoaded = () => {
          updateRegionStyles({
            mapRef,
            regionsViolations,
            regionsViolationsRef: refs.regionsViolationsRef,
          })
          mapRef.current?.off('styledata', onStyleLoaded)
        }
        mapRef.current?.on('styledata', onStyleLoaded)
        return
      }
      updateRegionStyles({
        mapRef,
        regionsViolations,
        regionsViolationsRef: refs.regionsViolationsRef,
      })
    }
  }, [regionsViolations, mapRef, zoomLevel, refs.regionsViolationsRef])

  // Update county styles
  useEffect(() => {

    if (mapRef.current && countyViolations) {
      updateCountyStyles(
        mapRef,
        countyViolations,
        refs.countyViolationsRef,
        zoomLevel,
        prevSelectedCode,
      )
    }
  }, [countyViolations, mapRef, zoomLevel, refs.countyViolationsRef])

  // Update search radius styles
  useEffect(() => {

    if (mapRef.current && boundingBox) {
      updateBoundingBoxStyles(mapRef, boundingBox)
    }

    if (selectedAddress) {
      const { code } = stateToRegionByName[selectedAddress.region] || {}
      const options = {
        params: {
          state_abbr: code,
        },
      }

      dispatch(WaterSystemsMetricsActions.fetchWaterSystemMetricsAsync({ options }) as any)
    }
  }, [boundingBox, mapRef, zoomLevel])

  // Handle markers
  useEffect(() => {

    if (coordinates?.length) {
      addMarkers(mapRef, coordinates, refs.markersRef, theme, dispatch, selectedAddress, isMobile)
    }
    return () => {
      removeMarkers(refs.markersRef)
    }
  }, [coordinates, mapRef, refs.markersRef, theme, dispatch, isMobile])

  const handleResize = () => mapRef.current?.resize()
  // Handle resize
  useEffect(() => {
    window.addEventListener('mapContainerResize', handleResize)
    return () => window.removeEventListener('mapContainerResize', handleResize)
  }, [mapRef])

  //map metrics
  useEffect(() => {
    waterSystemMapMetricsRef.current = waterSystemMapMetrics
  }, [waterSystemMapMetrics])

  useEffect(() => {
    statesRef.current = states

  }, [states])

  useEffect(() => {
    mapCenterRef.current = mapCenter
  }, [selectedCounty])

  useEffect(() => {
    if (!selectedAddress) {
      selectedAddressRef.current = null
      return
    }
    selectedAddressRef.current = selectedAddress
    const { latitude, longitude } = selectedAddress
    const zoom = 11
/*  dispatch(MapActions.setMapCenter({ lat: latitude, lng: longitude }))
    dispatch(MapActions.setMapZoom({zoom}))*/

    mapRef.current?.flyTo({
      center: [longitude, latitude],
      zoom,
    })
  }, [selectedAddress])

  // Handle selected state(dropdown) changes
  useEffect(() => {
    selectedStateRef.current = selectedState

    if (selectedState?.location) {

      const [lat, lng] = selectedState.location
      const zoom = selectedState.default_zoom
      //dispatch(MapActions.setMapCenter({ lat, lng }))
      //dispatch(MapActions.setMapZoom({zoom}))


      mapRef.current?.flyTo({
        center: [lng, lat],
        zoom:4,
      })
      mapRef.current?.once('moveend',()=>{
        mapRef.current?.flyTo({
          center: [lng, lat],
          zoom,
        })
      })
    }
  }, [selectedState, dispatch, mapRef])
}
